module.exports = __webpack_public_path__ + "static/media/bachelor_degree.6c3fa76e.jpg";